import { isEmpty } from "./datatype_helpers";

const validateTrainingModule = (training_module) => {
  let { name, default_frequency, category } = training_module;

  if (default_frequency === 0) default_frequency = default_frequency.toString();

  return {
    name: isEmpty(name) && "Must have a name",
    default_frequency: isEmpty(default_frequency) && "Must have a refresher period",
    category: isEmpty(category) && "Must have a category"
  }
}

const hasInvalidTrainingModuleDetails = (training_module) => {
  const errors = validateTrainingModule(training_module);
  const errorList= Object.values(errors).filter((e) => e);
  return errorList.length > 0;
}

const getCategoryText = (category) => {
  const categoryTexts = {
    all: "All Staff",
    other: "Team Specific"
  }
  const categoryText = categoryTexts[category];
  return categoryText ? categoryText : '';
}

const getDefaultFrequencyText = (defaultFrequency) => {
  let defaultFrequencyText = '';
  if (defaultFrequency === 0) defaultFrequencyText = 'As required';
  if (defaultFrequency> 0) defaultFrequencyText = `${defaultFrequency} years`;
  return defaultFrequencyText
}

export {
  validateTrainingModule,
  hasInvalidTrainingModuleDetails,
  getCategoryText,
  getDefaultFrequencyText
}


// WEBPACK FOOTER //
// ./src/helpers/training_module_helpers.js